import { FornecedorModel } from "../models/fornecedorModel"

export enum DadosFornecedorActionsTypes {
    CARREGAR = "CARREGAR",
    ATUALIZAR_CAMPO = "ATUALIZAR_CAMPO",
    RESETAR = "RESETAR",
}

export type DadosFornecedorActionModel =
    | {
          type: DadosFornecedorActionsTypes.CARREGAR
          payload: FornecedorModel
      }
    | {
          type: DadosFornecedorActionsTypes.ATUALIZAR_CAMPO
          payload: { campo: keyof FornecedorModel; valor: string | boolean }
      }
    | {
          type: DadosFornecedorActionsTypes.RESETAR
      }
